import { render, staticRenderFns } from "./IconTeam.vue?vue&type=template&id=4171f24e&scoped=true&"
import script from "./IconTeam.vue?vue&type=script&lang=js&"
export * from "./IconTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4171f24e",
  null
  
)

export default component.exports